
import '../src/normalize/normalize.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header/Header';
import Main from './components/main/Main'
import Bowler from './components/bowler/Bowler'
import Footer from './components/footer/Footer';
import Menu from './components/menu/Menu';
import useMultiIntersectionObserver from './components/section/useMultiIntersectionObserver'
function App() {
  const [visibleElements, elementsRef, setIsScrolling] = useMultiIntersectionObserver();
  const { isOpenMenu, toggleMenu } = Menu();
  return (
    <>
      <Router>
        <Header visibleElements={visibleElements} elementsRef={elementsRef}
          setIsScrolling={setIsScrolling} isOpenMenu={isOpenMenu} toggleMenu={toggleMenu} />
        <Routes>
          <Route
            path="/"
            element={<Main visibleElements={visibleElements} elementsRef={elementsRef} />}
          />
          <Route
            path="/bowler"
            element={<Bowler visibleElements={visibleElements} elementsRef={elementsRef} />}
          />
        </Routes>
        <Footer setIsScrolling={setIsScrolling} isOpenMenu={isOpenMenu} toggleMenu={toggleMenu} />
      </Router>
    </>
  );
}

export default App;
